/* hs-eslint ignored failing-rules */
/* eslint-disable hubspot-dev/no-confusing-browser-globals */

'use es6';

import { fromJS, Map as ImmutableMap, List } from 'immutable';
import { push } from './historyActions';
import { createAction } from 'redux-actions';
import Url from 'urlinator/Url';
import getIn from 'transmute/getIn';
import { SimpleDate, toFormattedString } from 'UIComponents/core/SimpleDate';
import * as reportTemplatesApi from '../api/reportTemplatesApi';
import * as reportsApi from '../api/reportsApi';
import { fetchAiReportsSearch, chirpFetchAiReportSearch } from 'reporting-discover-components/api/aiSearchApi';
import actionTypes from '../constants/actionTypes';
import * as FILTERS from '../constants/reportFilters';
import { initialState } from '../reducers/reportsReducer';
import { getRootUrl, getNonFilterRelatedParams } from '../utils/urls';
import { selectQueryFilters, selectTemplatesLimit, selectIsUnusedFilterActive } from '../selectors/reportsSelector';
import { selectedRowsActions } from '../redux/selectedRows';
import { URL_DATE_FORMAT } from '../lib/getInitialFilters';
import { trackEvent, EVENTS } from '../lib/usageTracker';
const {
  GET_SAVED_REPORTS_REQUESTED,
  GET_SAVED_REPORTS_SUCCEEDED,
  GET_SAVED_REPORTS_FAILED,
  GET_REPORT_TEMPLATE_SEARCH_REQUESTED,
  GET_REPORT_TEMPLATE_SEARCH_SUCCEEDED,
  GET_REPORT_TEMPLATE_SEARCH_FAILED,
  GET_ALL_RESTORABLE_REPORTS_REQUESTED,
  GET_ALL_RESTORABLE_REPORTS_SUCCEEDED,
  GET_ALL_RESTORABLE_REPORTS_FAILED,
  GET_REPORT_REQUESTED,
  GET_REPORT_SUCCEEDED,
  GET_REPORT_FAILED,
  CLEAR_REPORT,
  UPDATE_REPORT_REQUESTED,
  UPDATE_REPORT_SUCCEEDED,
  UPDATE_REPORT_FAILED,
  GET_REPORT_COUNTS_REQUESTED,
  GET_REPORT_COUNTS_SUCCEEDED,
  GET_REPORT_COUNTS_FAILED,
  GET_FILTERED_REPORT_COUNTS_REQUESTED,
  GET_FILTERED_REPORT_COUNTS_SUCCEEDED,
  GET_FILTERED_REPORT_COUNTS_FAILED,
  SET_FILTERS,
  CLEAR_FILTERS,
  SET_TEMPLATES_LIMIT,
  GET_AI_SEARCH_REQUESTED,
  GET_AI_SEARCH_SUCCEEDED,
  GET_AI_SEARCH_FAILED
} = actionTypes;
const setFilters = createAction(SET_FILTERS);
const clearFilters = createAction(CLEAR_FILTERS);
const savedReportsRequested = createAction(GET_SAVED_REPORTS_REQUESTED);
const savedReportsSucceeded = createAction(GET_SAVED_REPORTS_SUCCEEDED);
const savedReportsFailed = createAction(GET_SAVED_REPORTS_FAILED);
const reportTemplateSearchRequested = createAction(GET_REPORT_TEMPLATE_SEARCH_REQUESTED);
const reportTemplateSearchSucceeded = createAction(GET_REPORT_TEMPLATE_SEARCH_SUCCEEDED);
const reportTemplateSearchFailed = createAction(GET_REPORT_TEMPLATE_SEARCH_FAILED);
const setTemplatesLimit = createAction(SET_TEMPLATES_LIMIT);
const reportRequested = createAction(GET_REPORT_REQUESTED);
const reportSucceeded = createAction(GET_REPORT_SUCCEEDED);
const reportFailed = createAction(GET_REPORT_FAILED);
export const clearReport = createAction(CLEAR_REPORT);
const updateReportRequested = createAction(UPDATE_REPORT_REQUESTED);
export const updateReportSucceeded = createAction(UPDATE_REPORT_SUCCEEDED);
const updateReportFailed = createAction(UPDATE_REPORT_FAILED);
const getReportCountsRequested = createAction(GET_REPORT_COUNTS_REQUESTED);
const getReportCountsSucceeded = createAction(GET_REPORT_COUNTS_SUCCEEDED);
const getReportCountsFailed = createAction(GET_REPORT_COUNTS_FAILED);
const aiSearchRequested = createAction(GET_AI_SEARCH_REQUESTED);
const aiSearchSucceeded = createAction(GET_AI_SEARCH_SUCCEEDED);
const aiSearchFailed = createAction(GET_AI_SEARCH_FAILED);
const allRestorableReportsRequested = createAction(GET_ALL_RESTORABLE_REPORTS_REQUESTED);
const allRestorableReportsSucceeded = createAction(GET_ALL_RESTORABLE_REPORTS_SUCCEEDED);
const allRestorableReportsFailed = createAction(GET_ALL_RESTORABLE_REPORTS_FAILED);
const getFilteredReportCountRequested = createAction(GET_FILTERED_REPORT_COUNTS_REQUESTED);
const getFilteredReportCountSucceeded = createAction(GET_FILTERED_REPORT_COUNTS_SUCCEEDED);
const getFilteredReportCountFailed = createAction(GET_FILTERED_REPORT_COUNTS_FAILED);
export const getReports = () => (dispatch, getState) => {
  const state = getState();
  const filters = selectQueryFilters(state);
  const unusedActive = selectIsUnusedFilterActive(state);
  dispatch(savedReportsRequested());
  const getReportsRequest = unusedActive ? reportsApi.getUnusedReports : reportsApi.getReportsWithEarlyRequester;
  return getReportsRequest(filters).then(reports => {
    dispatch(savedReportsSucceeded(reports));
    return reports;
  }).catch(exception => {
    // eslint-disable-next-line no-console
    console.error(exception);
    dispatch(savedReportsFailed(exception));
  });
};
export const getReportTemplateSearchResults = () => (dispatch, getState) => {
  const filters = selectQueryFilters(getState());
  dispatch(reportTemplateSearchRequested());
  return reportTemplatesApi.getReportTemplates({
    search: filters.search,
    hiddenFromReportList: false
  }).then(reports => {
    dispatch(reportTemplateSearchSucceeded(reports));
    return reports;
  }).catch(exception => {
    // eslint-disable-next-line no-console
    console.error(exception);
    dispatch(reportTemplateSearchFailed(exception));
  });
};
export const clearReportTemplates = () => dispatch => {
  dispatch(reportTemplateSearchSucceeded(List()));
  dispatch(aiSearchSucceeded(undefined));
};
export const updateReportTemplatesLimit = limit => (dispatch, getState) => {
  const updatedTemplatesLimit = limit || selectTemplatesLimit(getState()) + 15;
  dispatch(setTemplatesLimit(updatedTemplatesLimit));
};
export const getRestorableReports = () => (dispatch, getState) => {
  const filters = selectQueryFilters(getState());
  dispatch(allRestorableReportsRequested());
  return reportsApi.getRestorableReports(filters).then(restorableReports => {
    dispatch(allRestorableReportsSucceeded(restorableReports));
    return restorableReports;
  }).catch(exception => {
    // eslint-disable-next-line no-console
    console.error(exception);
    dispatch(allRestorableReportsFailed(exception));
  });
};
const toDateString = date => {
  const simpleDate = date ? new SimpleDate(date) : null;
  return toFormattedString(simpleDate, URL_DATE_FORMAT);
};
const splitDateFilterIntoStartAndEnd = filters => {
  const updatedAt = filters[FILTERS.UPDATED_AT];
  const lastViewedAt = filters[FILTERS.LAST_VIEWED_AT];
  return ImmutableMap(Object.assign({}, filters, {
    startDate: updatedAt ? toDateString(updatedAt.startDate) : null,
    endDate: updatedAt ? toDateString(updatedAt.endDate) : null,
    lastViewedAt: lastViewedAt ? toDateString(lastViewedAt.date) : null
  }));
};
const setURL = (filtersObj, dispatch) => {
  const excludedValues = [null, undefined, '', 'ALL'];
  const queryFilters = splitDateFilterIntoStartAndEnd(filtersObj.toJS()).filter((val, key) => !excludedValues.includes(val) && key !== FILTERS.UPDATED_AT && key !== FILTERS.LAST_VIEWED_AT && val !== initialState.getIn(['filters', key])).toJS();
  const rootUrl = getRootUrl();
  const url = new Url(location);
  const nonFilterRelatedParams = getNonFilterRelatedParams(url.params);
  url.clearParams();
  url.upsertParams(Object.assign({}, queryFilters, nonFilterRelatedParams));
  const pathplus = url.pathplus;
  const destinationPath = pathplus.replace(rootUrl, '');
  dispatch(push(destinationPath));
};
export const getFilteredReportCount = () => (dispatch, getState) => {
  const filters = selectQueryFilters(getState());
  dispatch(getFilteredReportCountRequested());
  return reportsApi.getFilteredReportCount(filters).then(reportCount => {
    dispatch(getFilteredReportCountSucceeded(reportCount));
    return reportCount;
  }).catch(exception => {
    // eslint-disable-next-line no-console
    console.error(exception);
    dispatch(getFilteredReportCountFailed(exception));
  });
};
export const setReportsFilters = filters => dispatch => {
  const filtersObj = fromJS(filters);
  setURL(filtersObj, dispatch);
  dispatch(setFilters(filtersObj));
  dispatch(getFilteredReportCount());
  dispatch(selectedRowsActions.clearSelectedRows());
  return dispatch(getReports());
};
export const getAiSearchResults = (search, templatesByKey) => dispatch => {
  if (search !== undefined && search.length > 0) {
    dispatch(aiSearchRequested());
    return fetchAiReportsSearch({
      userInput: search,
      clicks: 0,
      templatesByKey
    }).then(result => {
      trackEvent(EVENTS.aiReportTemplateSearch);
      dispatch(aiSearchSucceeded({
        chatId: result.chatId,
        templateSuggestions: result.templateSuggestions
      }));
      return result.templateSuggestions;
    }).catch(exception => {
      if ((exception === null || exception === void 0 ? void 0 : exception.errorCode) !== 'ABORT') {
        // eslint-disable-next-line no-console
        console.error(exception);
        dispatch(aiSearchFailed(exception));
      }
    });
  }
  return Promise.resolve(null);
};
export const getChirpAiSearchResults = (search, templatesByKey) => dispatch => {
  if (search !== undefined && search.length > 0) {
    dispatch(aiSearchRequested());
    return chirpFetchAiReportSearch(search, 4, 0.3, templatesByKey).then(({
      chatId,
      suggestions
    }) => {
      trackEvent(EVENTS.aiReportTemplateSearch);
      dispatch(aiSearchSucceeded({
        chatId,
        templateSuggestions: suggestions
      }));
    }).catch(error => {
      var _error$cause;
      if ((error === null || error === void 0 || (_error$cause = error.cause) === null || _error$cause === void 0 ? void 0 : _error$cause.errorCode) !== 'ABORT') {
        // eslint-disable-next-line no-console
        console.error(error);
        dispatch(aiSearchFailed(error));
      }
    });
  }
  return Promise.resolve(null);
};
export const setRestorableReportsFilters = filters => dispatch => {
  const filtersObj = fromJS(filters);
  setURL(filtersObj, dispatch);
  dispatch(setFilters(filtersObj));
  dispatch(selectedRowsActions.clearSelectedRows());
  return dispatch(getRestorableReports());
};
export const clearReportsFilters = () => dispatch => {
  const filtersObj = fromJS({});
  setURL(filtersObj, dispatch);
  dispatch(clearFilters());
  return dispatch(getReports());
};
export const getReport = id => (dispatch, getState) => {
  dispatch(reportRequested(id));
  const reportFromState = getIn(['reports', 'reports', 'reports'])(getState()).find(r => r.get('id') === id);
  return reportFromState ? Promise.resolve(reportFromState) : reportsApi.getReport(id).then(report => {
    dispatch(reportSucceeded(report));
    return report;
  }).catch(exception => {
    // eslint-disable-next-line no-console
    console.error(exception);
    dispatch(reportFailed(exception));
  });
};
export const getReportCounts = () => dispatch => {
  dispatch(getReportCountsRequested());
  return reportsApi.getReportCounts().then(reportCounts => {
    dispatch(getReportCountsSucceeded(reportCounts));
    return reportCounts;
  }).catch(exception => {
    // eslint-disable-next-line no-console
    console.error(exception);
    dispatch(getReportCountsFailed(exception));
  });
};
export const updateReport = (reportId, report) => dispatch => {
  dispatch(updateReportRequested(reportId));
  dispatch(selectedRowsActions.clearSelectedRows());
  return reportsApi.updateReport(reportId, report).then(() => {
    dispatch(updateReportSucceeded(report));
    return report;
  }).catch(exception => {
    // eslint-disable-next-line no-console
    console.error(exception);
    dispatch(updateReportFailed(exception));
  });
};